import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';


export const getRetailersRequest = createAsyncThunk('/getRetailersRequest', async () => {
  const response = await axios.get('/GetRetailersRequest');
  return response.data;
});

export const getRetailerDetails = createAsyncThunk('/getRetailerDetails', async (retailerId) => {
  const response = await axios.get(`/GetRetailerDetails/${retailerId}`);
  return response.data;
});

export const setRetailDetails = createAsyncThunk('/setRetailDetails', async (req) => {
  const response = await axios.post(`/SetRetailDetails`, req);
  return response.data;
});

const retailerSlice = createSlice({
  name: 'retailer',
  initialState: {
    loading: false,
    error: '',
    Retailers:[] ,
    RetailerDataControl:[]
  },
  reducers: {
  },
  extraReducers: {
    [getRetailersRequest.pending]: (state) => {
      state.loading = true;
    },
    [getRetailersRequest.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRetailersRequest.fulfilled]: (state, action) => {
      state.Retailers = action.payload;
      state.loading = false;
    },
    [getRetailerDetails.pending]: (state) => {
      state.loading = true;
    },
    [getRetailerDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRetailerDetails.fulfilled]: (state, action) => {
      state.RetailerDataControl = action.payload;
      state.loading = false;
    },
    [setRetailDetails.pending]: (state) => {
      state.loading = true;
    },
    [setRetailDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setRetailDetails.fulfilled]: (state, action) => {
      state.RetailerDataControl = action.payload;
      state.loading = false;
    }
  }
});
export const retailerActions = retailerSlice.actions;

export default retailerSlice;